import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, LinearProgress } from '@mui/material';

export interface AvProgressProps {
  value?: number;
  height?: number;
  width?: number;
  showBar?: boolean;
  textStyle?: React.CSSProperties;
}

const AvProgress: React.FC<AvProgressProps> = ({ value = 0, height = 8, width = 72, showBar = true, textStyle = {} }) => (
  <Box sx={{ ...flex.itemsCenter, gap: 1 }}>
    <Box
      sx={(theme: any) => ({
        color: value > 0 ? theme.palette.colors.positive[500] : theme.palette.colors.neutrals[500],
        fontSize: 12,
        minWidth: 31,
        textAlign: 'right',
        whiteSpace: 'nowrap',
        ...textStyle,
      })}>
      {Number.isNaN(value) ? '0' : value}%
    </Box>
    {showBar && (
      <LinearProgress
        variant="determinate"
        sx={{
          borderRadius: '3px',
          background: 'var(--color-surface-severity-none-secondary)',
          height,
          width,
          [`& .MuiLinearProgress-bar`]: { background: 'var(--dataviz-color-status-primary-success)', borderRadius: 0 },
        }}
        value={value || 0}
      />
    )}
  </Box>
);

export { AvProgress };
